<template>
  <div class="card p-6">
    <b-overlay :show="isLoading">
      <h6 class="mb-8 d-flex" style="cursor: pointer; align-items: center">
        <div @click="collapseInlandsfluege = !collapseInlandsfluege">
          <span v-if="editedSeason.inlandsfluege?.length > 0" class="mr-2">
            <b-icon
              v-if="!collapseInlandsfluege"
              style="color: #3699ff"
              icon="chevron-right"
              aria-hidden="true"
              :scale="1.2"
            ></b-icon>
            <b-icon
              v-else
              style="color: #3699ff"
              :scale="1.2"
              icon="chevron-down"
              aria-hidden="true"
            ></b-icon>
          </span>
          Inlandsflüge
        </div>
        <b-button
          v-if="!isFlugdatenDisabled"
          :disabled="!isNonSavedInlandsflug"
          :variant="isNonSavedInlandsflug ? 'outline-primary' : 'secondary'"
          size="sm"
          class="ml-3 inlandsflug-add"
          @click="addLocalInlandsflug"
        >
          <Plus :size="16" />
          Inlandsflug hinzufügen
        </b-button>
      </h6>
      <b-collapse
        v-if="editedSeason.inlandsfluege?.length > 0"
        id="collapse-inlandsflug"
        v-model="collapseInlandsfluege"
      >
        <div
          v-for="(inlandsflug, i) in sortedInlandsfluege"
          :key="'inlandsflug-' + inlandsflug.id"
          :style="inlandsflug?.isOnlyLocal && { 'background-color': '#f7f7f7' }"
          class="mb-8 p-4 rounded"
        >
          <h6 class="mb-4">
            {{ i + 1 }}. Inlandsflug
            <span
              v-if="!inlandsflug?.isOnlyLocal"
              class="ml-2"
              @click="deleteInlandsflug(inlandsflug.id)"
              style="cursor: pointer"
            >
              <i class="fas fa-trash" style="color: black"></i>
            </span>
          </h6>

          <div class="d-flex" style="gap: 16px">
            <b-form-group label="Tag" class="widthEditField">
              <b-form-input
                size="sm"
                v-model="inlandsflug.tag"
                :number="true"
                type="number"
                min="0"
                max="21"
                step="1"
                required
                :disabled="inlandsflug?.isOnlyLocal ? false : true"
              ></b-form-input>
            </b-form-group>
            <b-form-group label="Abflughafen" class="widthEditField">
              <AirportsSucheMultiselect
                :disabled="inlandsflug?.isOnlyLocal ? false : true"
                v-model="inlandsflug.abflughafenIataCode"
                :isMultipleAllowed="true"
                :openDirection="'top'"
                :filterCountry="reise?.reisekuerzel.substring(0, 2)"
              ></AirportsSucheMultiselect>
            </b-form-group>
            <b-form-group label="Zielflughafen" class="widthEditField">
              <AirportsSucheMultiselect
                v-model="inlandsflug.zielflughafenIataCode"
                :isMultipleAllowed="true"
                :openDirection="'top'"
                :filterCountry="reise?.reisekuerzel.substring(0, 2)"
              ></AirportsSucheMultiselect>
            </b-form-group>
            <b-form-group label="Einkauf" class="widthEditField">
              <AppSelect
                v-model="inlandsflug.einkauf"
                :options="einkaufOptions"
                label="Einkauf"
                placeholder="-"
                hide-search
              />
            </b-form-group>
          </div>
          <div class="d-flex" style="gap: 16px">
            <b-form-group label="Frühester Abflug" class="widthEditField">
              <DatePicker
                :lang="langConfig"
                type="time"
                v-model="inlandsflug.fruehesterAbflug"
                :format="formatDatetimepicker"
                :show-second="false"
                value-type="format"
                :append-to-body="false"
              ></DatePicker>
            </b-form-group>
            <b-form-group label="Späteste Ankunft" class="widthEditField">
              <DatePicker
                :lang="langConfig"
                type="time"
                v-model="inlandsflug.spaetesteAnkunft"
                :format="formatDatetimepicker"
                :show-second="false"
                :append-to-body="false"
                value-type="format"
                :disabled="inlandsflug.minimaleUmsteigezeit != '' && inlandsflug.minimaleUmsteigezeit != null"
              ></DatePicker>
            </b-form-group>
            <div style="display: flex; align-items: center; justify-content: center; font-size: 1.25rem">
              oder
            </div>
            <b-form-group label="Minimale Umsteigezeit" class="widthEditField">
              <b-form-input
                size="sm"
                v-model="inlandsflug.minimaleUmsteigezeit"
                :number="true"
                type="number"
                min="0"
                step="1"
                required
                :disabled="inlandsflug.spaetesteAnkunft != null"
              ></b-form-input>
            </b-form-group>
          </div>
          <div v-if="changedInlandsfluegeIds.includes(inlandsflug.id)" class="d-flex" style="gap: 8px">
            <b-button class="dialog-btn-secondary" @click="resetInlandsflug(inlandsflug.id)">
              Zurücksetzen
            </b-button>
            <b-button class="dialog-btn" variant="primary" @click="saveInlandsflug(inlandsflug)">
              Speichern
            </b-button>
          </div>
          <div v-if="inlandsflug?.isOnlyLocal" class="d-flex" style="gap: 8px">
            <b-button class="dialog-btn-secondary" @click="removeLocalInlandsfluege">Abbrechen</b-button>
            <b-button
              class="save-btn dialog-btn"
              :disabled="!isAllInlandsflugFieldsFilled"
              :variant="isAllInlandsflugFieldsFilled ? 'primary' : 'secondary'"
              @click="saveLocalInlandsflug(inlandsflug)"
            >
              Speichern
            </b-button>
          </div>
        </div>
      </b-collapse>
    </b-overlay>

    <DeleteConfirmationModal
      id="modalInlandsflugLoeschen"
      title="Inlandsflug löschen?"
      @confirm="confirmDeleteInlandsflug"
    >
      Soll der Inlandsflug wirklich gelöscht werden? Die Löschung wird auch für die Reisetermine dieser Saison
      übernommen.
    </DeleteConfirmationModal>
  </div>
</template>

<script>
import AirportsSucheMultiselect from '@/components/common/airports-suche-multiselect.vue';
import DatePicker from 'vue2-datepicker';
import { langConfig } from '@/core/common/helpers/utils.js';
import * as inlandsflugService from './services/inlandsflug-metadata.service';
import DeleteConfirmationModal from '@/components/common/delete-confirmation-modal.vue';
import { Plus } from 'lucide-vue';
import AppSelect from '@/components/common/app-select/app-select.vue';

export default {
  name: 'ReisenMetadataCardInlandsfluege',
  components: {
    AirportsSucheMultiselect,
    DatePicker,
    DeleteConfirmationModal,
    Plus,
    AppSelect,
  },
  props: {
    editedSeason: { type: Object, required: true },
    activeMetadata: { type: Object, default: null },
    reise: { type: Object, default: null },
    activeSaisonGueltigAb: { type: String, default: null },
  },
  data() {
    return {
      langConfig,
      formatDatetimepicker: 'HH:mm',
      einkaufOptions: [
        { value: 'Skr', text: 'SKR' },
        { value: 'Dmc', text: 'DMC' },
      ],
      collapseInlandsfluege: true,
      isLoading: false,
      // gemerkte Inlandsflug-ID für die Löschbestätigung
      pendingDeleteId: null,
    };
  },
  computed: {
    // Ohne Flug entfällt die Inlandsflugplanung, deshalb wird das Hinzufügen dann deaktiviert
    isFlugdatenDisabled() {
      return this.editedSeason.flugoption === 'ReiseOhneFlug';
    },
    // Inlandsflüge werden nach Reisetag aufsteigend sortiert dargestellt
    sortedInlandsfluege() {
      return this.editedSeason.inlandsfluege.slice().sort((a, b) => a.tag - b.tag);
    },
    // Liefert die IDs der Inlandsflüge, die gegenüber dem geladenen Stand geändert wurden; nur für diese werden Speichern/Zurücksetzen angezeigt
    changedInlandsfluegeIds() {
      return this.editedSeason?.inlandsfluege
        ?.filter(inlandsflug => {
          const originalInlandsflug = this.activeMetadata?.inlandsfluege?.find(
            inlandsflugOriginal => inlandsflugOriginal.id === inlandsflug.id
          );
          if (!originalInlandsflug || inlandsflug?.isOnlyLocal) return false;
          return (
            originalInlandsflug.tag !== inlandsflug.tag ||
            originalInlandsflug.zielflughafenIataCode !== inlandsflug.zielflughafenIataCode ||
            originalInlandsflug.abflughafenIataCode !== inlandsflug.abflughafenIataCode ||
            originalInlandsflug.einkauf !== inlandsflug.einkauf ||
            originalInlandsflug.fruehesterAbflug?.substring(0, 5) !== inlandsflug.fruehesterAbflug ||
            originalInlandsflug.spaetesteAnkunft?.substring(0, 5) !== inlandsflug.spaetesteAnkunft
          );
        })
        .map(item => item.id);
    },
    // Prüft, ob aktuell KEIN nur lokal angelegter (noch nicht gespeicherter) Inlandsflug offen ist; nur dann darf ein neuer angelegt werden
    isNonSavedInlandsflug() {
      return !this.editedSeason?.inlandsfluege?.some(inlandsflug => inlandsflug?.isOnlyLocal == true);
    },
    // Der Speichern-Button eines neuen Inlandsflugs wird erst aktiv, wenn alle Pflichtfelder gefüllt sind; Zeit ODER minimale Umsteigezeit reicht
    isAllInlandsflugFieldsFilled() {
      const localInlandsflug = this.editedSeason.inlandsfluege.find(
        inlandsflug => inlandsflug?.isOnlyLocal == true
      );
      if (localInlandsflug) {
        return (
          localInlandsflug.abflughafenIataCode?.length === 1 &&
          localInlandsflug.zielflughafenIataCode?.length === 1 &&
          localInlandsflug.tag !== null &&
          localInlandsflug.einkauf !== null &&
          ((localInlandsflug.fruehesterAbflug != null && localInlandsflug.spaetesteAnkunft != null) ||
            (localInlandsflug.fruehesterAbflug != null && localInlandsflug.minimaleUmsteigezeit !== null))
        );
      } else return false;
    },
  },
  methods: {
    // Öffnet die Löschbestätigung und merkt sich die betroffene Inlandsflug-ID bis zur Bestätigung
    deleteInlandsflug(id) {
      this.pendingDeleteId = id;
      this.$bvModal.show('modalInlandsflugLoeschen');
    },
    // Führt die Löschung nach Bestätigung aus; die Löschung wird per overwriteReisetermine=true auch auf die Reisetermine der Saison angewendet
    confirmDeleteInlandsflug() {
      const id = this.pendingDeleteId;
      this.$bvModal.hide('modalInlandsflugLoeschen');
      if (id == null) return;
      this.isLoading = true;
      const reisekuerzel = this.reise.reisekuerzel;
      inlandsflugService
        .remove(reisekuerzel, this.activeSaisonGueltigAb, id)
        .then(() => {
          this.toast('Erfolgreich gelöscht');
          if (this.activeMetadata) {
            this.activeMetadata.inlandsfluege = this.activeMetadata.inlandsfluege.filter(
              inlandsflug => inlandsflug.id !== id
            );
          }
          this.editedSeason.inlandsfluege = this.editedSeason.inlandsfluege.filter(
            inlandsflug => inlandsflug.id !== id
          );
        })
        .finally(() => {
          this.pendingDeleteId = null;
          this.isLoading = false;
        });
    },
    // Speichert einen neu angelegten (bisher nur lokalen) Inlandsflug
    async saveLocalInlandsflug(inlandsflug) {
      const overwriteReisetermine = await this.$bvModal.msgBoxConfirm(
        'Möchtest du den Inlandsflug für Reisetermine in dieser Saison übernehmen?',
        {
          centered: true,
          okTitle: 'Ja',
          cancelTitle: 'Nein',
        }
      );
      this.isLoading = true;
      return inlandsflugService
        .create(this.reise.reisekuerzel, this.activeMetadata.gueltigAb, inlandsflug, overwriteReisetermine)
        .then(resp => {
          const newInlandsflug = resp.data.result.value;
          this.isLoading = false;
          // insert new inlandsflug
          this.removeLocalInlandsfluege();
          this.addNewInlandsflug(newInlandsflug);
        })
        .catch(() => {
          this.isLoading = false;
          this.removeLocalInlandsfluege();
        });
    },
    // Entfernt die nur lokal angelegten Inlandsflüge aus der Arbeitskopie, z.B. bei Abbruch oder nach dem Speichern
    removeLocalInlandsfluege() {
      this.editedSeason.inlandsfluege = this.editedSeason.inlandsfluege.filter(
        inlandsflug => inlandsflug?.isOnlyLocal != true
      );
    },
    // Setzt einen bearbeiteten Inlandsflug auf den geladenen Ursprungsstand zurück
    resetInlandsflug(id) {
      this.editedSeason.inlandsfluege = this.editedSeason.inlandsfluege.map(inlandsflug => {
        if (inlandsflug.id === id) {
          const oldInlandsflug = this.activeMetadata.inlandsfluege.find(inlandsflug => inlandsflug.id === id);
          return {
            ...oldInlandsflug,
            spaetesteAnkunft: oldInlandsflug.spaetesteAnkunft?.substring(0, 5),
            fruehesterAbflug: oldInlandsflug.fruehesterAbflug?.substring(0, 5),
          };
        } else return inlandsflug;
      });
    },
    // Fügt den vom Server zurückgegebenen, neu gespeicherten Inlandsflug sowohl in die Arbeitskopie als auch in den geladenen Stand ein
    addNewInlandsflug(inlandsflug) {
      this.editedSeason.inlandsfluege = [
        {
          ...inlandsflug,
          spaetesteAnkunft: inlandsflug.spaetesteAnkunft?.substring(0, 5),
          fruehesterAbflug: inlandsflug.fruehesterAbflug?.substring(0, 5),
        },
        ...this.editedSeason.inlandsfluege,
      ];
      if (this.activeMetadata) {
        this.activeMetadata.inlandsfluege = [
          {
            ...inlandsflug,
          },
          ...this.activeMetadata.inlandsfluege,
        ];
      }
    },
    // Legt einen leeren, nur lokal existierenden Inlandsflug an (noch nicht am Server gespeichert); die feste id 999999 markiert diese Platzhalterzeile
    addLocalInlandsflug() {
      if (this.isNonSavedInlandsflug) {
        this.editedSeason.inlandsfluege = [
          {
            isOnlyLocal: true,
            id: 999999,
            abflughafenIataCode: null,
            zielflughafenIataCode: null,
            tag: null,
            einkauf: null,
            fruehesterAbflug: null,
            spaetesteAnkunft: null,
            minimaleUmsteigezeit: null,
          },
          ...this.editedSeason.inlandsfluege,
        ];
      }
      this.collapseInlandsfluege = true;
    },
    // Speichert Änderungen an einem bereits bestehenden Inlandsflug; Flughäfen können als Array oder String vorliegen und werden vereinheitlicht zu einem String zusammengefügt
    async saveInlandsflug(inlandsflug) {
      this.isLoading = true;

      inlandsflugService
        .update(this.reise.reisekuerzel, this.activeSaisonGueltigAb, inlandsflug)
        .then(response => {
          this.toast('Erfolgreich bearbeitet.');
          // item1 enthält Reisetermine, deren Inlandsflug nicht übernommen werden konnte; die Elternkomponente zeigt dafür ein Info-Modal
          const reiseterminNotUpdatedInlandsfluege = response.data.result.value.item1;
          if (reiseterminNotUpdatedInlandsfluege?.length > 0) {
            this.$emit('showNotUpdatedInlandsfluege', reiseterminNotUpdatedInlandsfluege);
          }
          // item2 enthält den aktualisierten Inlandsflug, mit dem der geladene Stand synchronisiert wird
          const result = response.data.result.value.item2;
          const inlandsflugToUpdate = this.activeMetadata.inlandsfluege.find(
            inl => inl.id === inlandsflug.id
          );
          inlandsflugToUpdate.tag = result.tag;
          inlandsflugToUpdate.einkauf = result.einkauf;
          inlandsflugToUpdate.fruehesterAbflug = result.fruehesterAbflug?.substring(0, 5);
          inlandsflugToUpdate.spaetesteAnkunft = result.spaetesteAnkunft?.substring(0, 5);
          inlandsflugToUpdate.minimaleUmsteigezeit = result.minimaleUmsteigezeit;
          inlandsflugToUpdate.abflughafenIataCode = result.abflughafenIataCode;
          inlandsflugToUpdate.zielflughafenIataCode = result.zielflughafenIataCode;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.widthEditField {
  width: 225px;
}

.inlandsflug-add {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.save-btn:disabled {
  cursor: default;
  pointer-events: all;
  opacity: 1;
  background-color: #e4e6ef;
  border-color: #e4e6ef;
  color: var(--text-subtle);
}

:deep(select:disabled),
:deep(input:disabled) {
  background-color: var(--surface-sunken) !important;
}

:deep(.mx-datepicker-content) {
  margin: 0 !important;
}
</style>
